import React from 'react';

export const Engraving = () => (
    <>
        <path d='M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z' />
        <path d='M16 7h4' />
        <path d='M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3' />
    </>
);